import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const termsUseModule = {
  namespaced: true,
  state: {
    termsUses: null,
    termsUse: null,
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  mutations,
  actions,
  getters,
};

export default termsUseModule;
